import React from 'react';
import { useRouter } from 'next/router';
import { getOfferFromPath, getOfferClassToken } from '../ProductVariants/helpers';
import { OFFER_MARKER_CLASSNAME } from './constants';

// An empty element carrying an offer specific class when the url has an ?offer= value, so
// page styles can react to the offer on pages without the product variants component, e.g.
// `.page:has(.kel-shopware-offer-marker--offer-xmas26) .card`. The token matches the
// variants wrapper's `--offer-<offer>` modifier. Renders nothing without a usable offer.
const OfferMarker = () => {
  const { asPath } = useRouter() || {};
  const offerClassToken = getOfferClassToken(getOfferFromPath(asPath));

  if (!offerClassToken) return null;

  return (
    <div
      className={`${OFFER_MARKER_CLASSNAME} ${OFFER_MARKER_CLASSNAME}--offer-${offerClassToken}`}
      data-offer={offerClassToken}
      aria-hidden="true"
    />
  );
};

export default OfferMarker;
